import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'

export const WheelBase = withFacetContext(
    FacetName.wheelbase,
    withFilterContext(FilterName.wheelbase, SearchFiltersDropdown, {
        title: 'Wheelbase',
        moreOptionsLabel: 'More options',
        hideLabel: true,
    })
)
